import {
    FETCH_CLAIM_HISTORY_REQUEST,
    FETCH_CLAIM_HISTORY_SUCCESS,
    FETCH_CLAIM_HISTORY_FAILURE,
  } from "./FetchClaimHistoryTypes";
  
  const initialState = {
    loading: false,
    claimHistory: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_CLAIM_HISTORY_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_CLAIM_HISTORY_SUCCESS:
        return {
          loading: false,
          claimHistory: action.payload,
          error: "",
        };
      case FETCH_CLAIM_HISTORY_FAILURE:
        return {
          loading: false,
          claimHistory: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  